<template>
  <div
    class="ui inverted system menu"
    v-bind:class="{ hidden: !logged_user.name }"
  >
    <!-- <a class="item menu" ref="menu">
      <i class="olive th icon"></i>
      {{ $t("menu") }}
    </a>-->
    <a class="item menu" v-on:click="home">
      <i class="olive home icon"></i>
      {{ $t("home") }}
    </a>
    <div class="right menu">
      <div class="ui dropdown item" @click="report_bug">
        <i class="olive bug icon"></i>
      </div>
      <div class="ui dropdown item" ref="lang_dropdown">
        <i class="language icon"></i>
        <div class="menu">
          <div class="header">{{ $t("language") }}</div>
          <div
            class="item"
            v-for="language in languages"
            v-bind:key="language.code"
            v-on:click="change_language(language)"
          >
            <i v-bind:class="language.flag"></i>
            {{ $t(language.name) }}
          </div>
        </div>
      </div>
      <div class="ui dropdown item" ref="user_menu">
        <i class="user icon"></i>
        {{ logged_user.name }}
        <div class="menu">
          <div class="header">
            {{ $t("user") }}
          </div>
          <div class="item" v-on:click="log_off">
            <i class="sign out icon"></i>
            {{ $t("sign out") }} ({{ logged_user.username }})
          </div>
          <div class="item" v-on:click="change_password">
            <i class="lock icon"></i>
            {{ $t("change password") }}
          </div>
          <div class="divider"></div>
          <div class="header">
            {{ $t("system") }}
          </div>
          <div class="item" v-on:click="reload_session">
            <i class="refresh icon"></i>
            {{ $t("update session") }}
          </div>
          <div class="item" v-on:click="reload_system">
            <i class="red refresh icon"></i>
            {{ $t("update system") }}
          </div>
        </div>
      </div>
    </div>
    <password-change-modal ref="password_change_modal" />
    <bug-modal ref="bug_modal" />
  </div>
</template>

<script>
import i18n from "@/i18n";
import BugModal from "@/components/BugModal";
import PasswordChangeModal from "@/components/PasswordChangeModal";
import { reload_session } from "@/utils";

export default {
  name: "Navbar",
  props: { session: Boolean },
  components: { PasswordChangeModal, BugModal },
  mounted() {
    // window.jQuery(".ui.dropdown").dropdown();
    window.jQuery(this.$refs.lang_dropdown).dropdown();
    window.jQuery(this.$refs.user_menu).dropdown();
    this.logged_user = this.$session.get("user") || {};
    if (this.logged_user.username) {
      this.$emit("set_active_nav", "modul");
    }
  },
  data() {
    return {
      languages: [
        { name: "spanish", code: "es", flag: "gt flag" },
        { name: "english", code: "en", flag: "us flag" },
        { name: "french", code: "fr", flag: "fr flag" },
      ],
      logged_user: {},
    };
  },
  methods: {
    log_off() {
      this.$session.destroy();
      setTimeout(() => {
        this.$router.replace({ name: "Index" });
        this.logged_user = {};
      }, 200);
    },
    change_password() {
      let vm = this;
      vm.$refs.password_change_modal.show_modal(vm.logged_user);
    },
    change_language(language) {
      i18n.locale = language.code;
    },
    home() {
      let current_route = this.$route.name;
      if (current_route != "Home")
        this.$router.push({
          name: "Home",
        });
    },
    report_bug() {
      let vm = this;
      vm.$refs.bug_modal.show_modal();
    },
    update_nav(user) {
      // console.log("updating nav", user);
      this.logged_user = user;
    },
    reload_session() {
      reload_session(this);
    },
    reload_system() {
      // location.reload(true);
      window.jQuery
        .ajax({
          url: window.location.href,
          headers: {
            Pragma: "no-cache",
            Expires: -1,
            "Cache-Control": "no-cache",
          },
        })
        .done(function () {
          window.location.reload(true);
        });
    },
  },
  computed: {},
};
</script>

<style>
.system.menu {
  margin-bottom: 0 !important;
}
</style>
